/** AbortController による通常の中断かどうかを判定する。 */
export function isAbortError(error: unknown): boolean {
	return error instanceof DOMException && error.name === "AbortError";
}
